import axios from 'axios';
import React, { KeyboardEvent, useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import homeState from '../../../atoms/home';
import messagesState from '../../../atoms/messages';
import myInfoState from '../../../atoms/myinfo';
import participantsState from '../../../atoms/participants';
import userDetailsState from '../../../atoms/userDetails';
import { getUser } from '../../../connector';
import emitGetUserDetails from '../../../connector/emits/getUserDetails';
import emitSendMessage from '../../../connector/emits/sendMessage';
import { MessageType, SystemMessageType } from '../../../connector/type';
import PlainMessage from '../../Room/Chatting/PlainMessage';
import SystemMessage from '../../Room/Chatting/SystemMessage';
import './HomeChatting.scoped.scss'
import environment from '../../../environment';
import roomDetailState, { kickState } from '../../../atoms/roomDetail';
import emitGetIsKick from '../../../connector/emits/getIsKick';

const infinity = Math.pow(2, 31);

function getScrolledPercent(element: HTMLElement) {
  if (element == null) {
    return 0;
  }
  const scrollRange = element.scrollHeight - element.offsetHeight;
  return Math.round((element.scrollTop / scrollRange) * 100);
}

function HomeChatting() {
  // Recoil
  const [myInfo] = useRecoilState(myInfoState);
  const [roomDetail] = useRecoilState(roomDetailState);
  const [home] = useRecoilState(homeState);
  const [participants] = useRecoilState(participantsState);
  const [userDetails] = useRecoilState(userDetailsState);
  const [messages] = useRecoilState(messagesState);
  const [kick] = useRecoilState(kickState);

  // Local state
  const [hasFirstScrolled, setHasFirstScrolled] = useState(false);
  const [message, setMessage] = useState('');
  const [lastScrolledPercent, setLastScrolledPercent] = useState(0);
  const messagesReference = useRef<HTMLDivElement>(null);
  const noticesUlRef = useRef<HTMLUListElement>(null);
  const [notices, setNotices] = useState<unknown>([]);

  const isGuest = myInfo.userDetail?.id == null || myInfo.userDetail?.id === '';

  // Effect
  useEffect(() => {
    setTimeout(() => {
      if (messagesReference.current != null) {
        messagesReference.current.scrollTop =  messagesReference.current.scrollHeight;;
        setLastScrolledPercent(100);
      }
      messagesReference.current?.addEventListener('scroll', (event) => {
        if (messagesReference.current == null) {
          return;
        }
        setLastScrolledPercent(getScrolledPercent(messagesReference.current));
      });
    }, 500);
    setInterval(() => {
      emitGetIsKick('square');
    }, 1000);
    (async () => {
      const noticesRes = await axios.get(`${environment.SERVER_URL}/chat/get_notice.php`);
      setNotices(noticesRes.data);
    })();
  }, []);

  useEffect(() => {
    if ((notices as unknown[]).length > 0) {
      (function () {
        let noticesSequance = 0;
        setInterval(() => {
          if (noticesUlRef.current == null) {
            return;
          }
          ++noticesSequance;
          const noticesUl = noticesUlRef.current;
          noticesUl.style.marginLeft = `-${(noticesSequance) * 100}vw`;
          if (noticesSequance === (notices as unknown[]).length) {
            setTimeout(() => {
              noticesUl.style.transition = 'none';
              noticesUl.style.marginLeft = '0vw';
              noticesSequance = 0;
              setTimeout(() => {
                noticesUl.style.transition = 'all 1s';
              }, 100);
            }, 1000);
          }
        }, 5000);
      })();
    }
  }, [notices]);

  useEffect(() => {
    emitGetUserDetails(participants.users);
  }, [participants.users]);

  useEffect(() => {
    if (messagesReference.current == null) {
      return;
    }
    if (!hasFirstScrolled && messages.messages.length > 0) {
      setHasFirstScrolled(true);
      messagesReference.current.scrollTop =  messagesReference.current.scrollHeight;;
      return;
    }
    if (lastScrolledPercent === 100) {
      messagesReference.current.scrollTop =  messagesReference.current.scrollHeight;;
    }
  }, [hasFirstScrolled, lastScrolledPercent, messages]);

  // Event
  const onKeyPressnput = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  // Handle
  const sendMessage = () => {
    if (message.length === 0) {
      return;
    }
    emitSendMessage('square', {
      user: getUser(),
      messageType: MessageType.PLANE,
      contents: message,
    });
    setMessage('');
  }

  return (
    <div>
      <div className="home-chatting-notices">
        <ul ref={noticesUlRef}>
          {
            (notices as { key: any, value: any }[]).map((notice, index) => {
              const castedNotice = (notices as { key: any, value: any }[]);
              if (index === castedNotice.length - 1) {
                return (
                  <React.Fragment key={index}>
                    <li>
                      <a href={notice.value} target="contents_frame">
                        {notice.key}
                      </a>
                    </li>
                    <li>
                      <a href={castedNotice[0].value} target="contents_frame">
                        {castedNotice[0].key}
                      </a>
                    </li>
                  </React.Fragment>
                );
              } else {
                return (
                  <li key={index}>
                    <a href={notice.value} target="contents_frame">
                      {notice.key}
                    </a>
                  </li>
                );
              }
            })
          }
        </ul>
      </div>

      <div 
        ref={messagesReference}
        className="home-chatting-messages"
        style={{ fontSize: home.fontSize }}
      >
        {
          messages.roomId === 'square'
            ? messages.messages.map((message, index) => {
              if (message.messageType === MessageType.SYSTEM) {
                const contents = message.contents as { systemMessageType: SystemMessageType };
                if (contents.systemMessageType === SystemMessageType.JOIN_USER) {
                  return null;
                }
                return (
                  <SystemMessage
                    key={index}
                    userId={message.user} 
                    userDetail={userDetails.get(message.user)}
                    contents={contents}
                  />
                );
              }
              return (
                <PlainMessage 
                  key={index}
                  userId={message.user} 
                  userDetail={userDetails.get(message.user)}
                  contents={message.contents as string}
                />
              );
            })
            : null
        }
        
      </div>
      <div className="home-chatting-input">
        <input 
          type="text" 
          placeholder={
            myInfo.id === 'admin' || roomDetail.owner === myInfo.id || roomDetail.managers.includes(myInfo.id) ? '내용 입력'
            : isGuest ? '로그인 후 이용해주세요.'
            : kick === 'F' ? '벙어리 상태에는 채팅을 입력할 수 없습니다.'
            : roomDetail.isAllFreezing ? '현재 채팅방이 얼려있습니다.'
            : '내용 입력'
          }
          disabled={!(myInfo.id === 'admin' || roomDetail.owner === myInfo.id || roomDetail.managers.includes(myInfo.id)) && (isGuest || kick === 'F' || roomDetail.isAllFreezing)}
          id="chat_input" 
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={onKeyPressnput}
          autoComplete="off"
        />
        <button onClick={sendMessage}></button>
      </div>
    </div>
  );
}

export default HomeChatting;
